import Request from '../Request.utils'
export interface ISubmitFeedbackRequestBody {
  account?: string;
  appVersion?: string;
  category?: string;
  debugLog?: string;
  device?: string;
  message?: string;
  screen?: string;
  screenshot?: string;
}
export interface IListFeedbackRequestQuery {
  field1?: string;
  field2?: string;
  search?: string;
}


class FeedbackAPI {
  submitFeedback = async (body: ISubmitFeedbackRequestBody) => {
    const res = await Request.call('/api/feedback', 'POST', undefined, undefined, body, );
    return res;
  }
  listFeedback = async (query: IListFeedbackRequestQuery) => {
    const res = await Request.call('/api/feedback', 'GET', undefined, query, undefined, );
    return res;
  }
}
export default new FeedbackAPI()